import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { GuideData, GuidePreview, PlainDoc } from "../../core/types/guide"
import {Guide} from '../../core/types/guide';
import TranscriptEditor from '../../../../platform/src/pages/editor/video/components/TranscriptEditor/TranscriptEditor';
import { RootState } from '@gigauser/common/src/redux/store';



interface EditsMade {
    value: {
        saveInProgress: boolean,
        unsavedChanges: boolean //for any and all changes
        unsavedOgVideoEdits: boolean, //only for changes involved in generating the edited video
        transcriptEdited:boolean
    }
}

const initialState: EditsMade = {
    value: {
        saveInProgress: false,
        unsavedChanges: false, 
        unsavedOgVideoEdits: false,
        transcriptEdited: false,
    }
}

export const guideSlice = createSlice({
    name: 'guide', 
    initialState,
    reducers: {
        setTranscriptEdited: (state, action: PayloadAction<boolean>)=>{
            state.value.unsavedChanges = true
            state.value.transcriptEdited = action.payload
        },
        // setGeneratingVideo: (state, action: PayloadAction<boolean>)=>{
        //     state.value.generatingVideo = action.payload
        // },
        setUnsavedChanges: (state, action: PayloadAction<boolean>)=>{
            state.value.unsavedChanges = action.payload
        },

        setUnsavedOgVideoEdits: (state, action: PayloadAction<boolean>) =>{
            state.value.unsavedOgVideoEdits = action.payload
        }, 

        setSaveInProgress: (state, action: PayloadAction<boolean>) => {
            state.value.saveInProgress = action.payload
        }


    }
})

export const {setTranscriptEdited, setUnsavedChanges, setUnsavedOgVideoEdits, setSaveInProgress} = guideSlice.actions
// Other code such as selectors can use the imported `RootState` type
export const selectUnsavedChanges = (state:RootState)=>state.editsMade.value.unsavedChanges
export default guideSlice.reducer


